import React from 'react';
import './css/root.css';
import './css/input.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CategoriasProvider from './context/CategoriasContext';
import CarritoProvider from './context/CarritoContext';
import { DolarProvider } from './context/ValorDolarContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DolarProvider>
    <CategoriasProvider>
    <CarritoProvider>
    <BrowserRouter>
          <Navbar/>
        <div className='w-full min-h-screen'>
          <App />
      </div>
          <Footer/>
      </BrowserRouter>
    </CarritoProvider>
    </CategoriasProvider>
  </DolarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
